// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Use event delegation at document level for all click events.
// This works regardless of Turbo navigations because the listener is on document,
// and we fetch the modal elements each time a click occurs.

document.addEventListener("click", (event) => {
  // Handle confirmation modal triggers
  const trigger = event.target.closest("[data-confirm-modal]");
  if (trigger) {
    event.preventDefault();

    const modal = document.getElementById("confirm-modal");
    const titleEl = document.getElementById("confirm-title");
    const messageEl = document.getElementById("confirm-message");
    const iconEl = document.getElementById("confirm-icon");
    const submitBtn = document.getElementById("confirm-submit");

    if (!modal || !titleEl || !messageEl || !submitBtn || !iconEl) return;

    // Default delete styling
    const defaults = {
      title: "Confirm Deletion",
      message: "Are you sure you want to delete this? This action cannot be undone.",
      buttonText: "Delete",
      buttonClass: "bg-red-600 hover:bg-red-700",
      iconClass: "bg-red-100",
      iconSvg: `<svg class="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
                </svg>`
    };

    const config = {
      title: trigger.dataset.confirmTitle || defaults.title,
      message: trigger.dataset.confirmMessage || defaults.message,
      buttonText: trigger.dataset.confirmButton || defaults.buttonText,
      buttonClass: trigger.dataset.confirmButtonClass || defaults.buttonClass,
      iconClass: trigger.dataset.confirmIconClass || defaults.iconClass,
      iconSvg: trigger.dataset.confirmIconSvg || defaults.iconSvg
    };

    titleEl.textContent = config.title;
    messageEl.textContent = config.message;
    submitBtn.textContent = config.buttonText;
    submitBtn.className = `flex-1 px-4 py-2.5 rounded-lg text-white font-medium transition text-sm ${config.buttonClass}`;
    iconEl.className = `mx-auto h-12 w-12 rounded-full flex items-center justify-center mb-4 ${config.iconClass}`;
    iconEl.innerHTML = config.iconSvg;

    modal.classList.remove("hidden");
    modal.classList.add("flex");

    // Store the trigger on the modal element for use in confirm/cancel
    modal.dataset.confirmActionHref = trigger.href;
    modal.dataset.confirmActionMethod = trigger.dataset.method || "";
  }
});

// Handle cancel and backdrop clicks
document.addEventListener("click", (event) => {
  const modal = document.getElementById("confirm-modal");
  if (!modal) return;

  if (event.target.id === "confirm-cancel") {
    modal.classList.add("hidden");
    modal.classList.remove("flex");
    return;
  }

  // Backdrop click (click on modal itself)
  if (event.target === modal) {
    modal.classList.add("hidden");
    modal.classList.remove("flex");
  }
});

// Handle confirm button click
document.addEventListener("click", (event) => {
  if (event.target.id !== "confirm-submit") return;

  const modal = document.getElementById("confirm-modal");
  if (!modal) return;

  const href = modal.dataset.confirmActionHref;
  const method = modal.dataset.confirmActionMethod;

  if (href) {
    if (method && method.toLowerCase() === "post") {
      // Create a hidden form to submit POST
      const form = document.createElement("form");
      form.method = "POST";
      form.action = href;
      form.style.display = "none";

      const csrfToken = document.querySelector('meta[name="csrf-token"]');
      if (csrfToken) {
        const csrfInput = document.createElement("input");
        csrfInput.type = "hidden";
        csrfInput.name = "authenticity_token";
        csrfInput.value = csrfToken.content;
        form.appendChild(csrfInput);
      }

      // If the original link had data-method, we already set it.
      if (method.toLowerCase() === "delete") {
        const methodInput = document.createElement("input");
        methodInput.type = "hidden";
        methodInput.name = "_method";
        methodInput.value = "delete";
        form.appendChild(methodInput);
      }

      document.body.appendChild(form);
      form.submit();
    } else {
      // Normal link navigation
      window.location.href = href;
    }
  }

  modal.classList.add("hidden");
  modal.classList.remove("flex");
});
